export default "__VITE_ASSET__BORQq$od__"